
import { Options, Vue } from "vue-class-component";
import LeftPanel from "@/components/leftPanel/LeftPanel.vue";
import RightPanel from "@/components/rightPanel/RightPanel.vue";
@Options({
  components: {
    LeftPanel,
    RightPanel
  }
})
export default class Header extends Vue {
  Pin = "";
}
